import { useState, useEffect } from 'react';

/**
 * Single change event for the whole Growth data layer. Every writer in
 * services/growth dispatches it; useGrowthVersion() re-renders any Growth
 * component on the next change. Same pattern as APP_CONFIG_CHANGE_EVENT in
 * useAppConfig.js — this is what lets components read synchronously and
 * still stay fresh when another tab/panel writes.
 */
export const GROWTH_CHANGE_EVENT = 'peoplevue_growth_change';

export function emitGrowthChange() {
  try {
    window.dispatchEvent(new Event(GROWTH_CHANGE_EVENT));
  } catch {
    // non-browser (tests) — ignore
  }
}

/** Bumps a counter on every growth change so consumers re-read the stores. */
export function useGrowthVersion() {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const handle = () => setVersion((v) => v + 1);
    window.addEventListener(GROWTH_CHANGE_EVENT, handle);
    return () => window.removeEventListener(GROWTH_CHANGE_EVENT, handle);
  }, []);
  return version;
}

/** Shared id helper (savedFiltersService convention). */
export function newId(prefix) {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
}
